import type { Automation } from "./fixtures";
import { StatusDot } from "./badges";

/**
 * Scope chip — the chat input's "talking to ● {Automation}" signal (Automations Phase 4, piece 3).
 * Rendered by the chat composer's `ChatScopeBar`; the × clears the scope back to the general
 * workspace. Visual scoping only — message routing is deferred/live work.
 */
export function ScopeChip({
  agent,
  onClear,
}: {
  agent: Automation | null;
  onClear?: () => void;
}) {
  if (!agent) {
    return (
      <div className="autoui-scopechip autoui-scopechip--general">
        <span>general workspace</span>
      </div>
    );
  }
  return (
    <div className="autoui-scopechip" style={{ borderColor: agent.color }}>
      <StatusDot color={agent.color} status={agent.status} />
      <span>talking to {agent.name}</span>
      {onClear ? (
        <button
          type="button"
          className="autoui-scopechip__x"
          aria-label="Clear scope"
          onClick={onClear}
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
